export default (filter, operations) => {
    const newFilter = JSON.parse(JSON.stringify(filter));

    for (const key in operations) {
        if (!Object.prototype.hasOwnProperty.call(operations, key)) {
            continue;
        }

        if (newFilter[key] && !newFilter[key].operation) {
            newFilter[key] = {
                operation: operations[key],
                values: newFilter[key],
            };
        }
    }

    return newFilter;
};
